
import React from "react";
import Container1 from "./Container1.jsx";
import "./LoginSignUpStyle.css";
function LoginSignUp() {
  return (
    <div className="LoginSignUp">
<Container1></Container1>
    </div>
  );
}

export default LoginSignUp;
